export default [
  {
    path: '/setting',
    name: 'settingApp',
    component: () => import(/* webpackChunkName: "settingApp" */'@/views/setting/setting-app'),
    children: [
      {
        path: '',
        name: 'settingMain',
        component: () => import(/* webpackChunkName: "settingMain" */'@/views/setting/comp/setting-main'),
      },
      {
        path: 'terms/pageInfo=3',
        name: 'termsView',
        component: () => import(/* webpackChunkName: "termsView" */'@/views/setting/comp/setting-terms'),
      },
      {
        path: 'privacy-policy/pageInfo=3',
        name: 'privacyPolicyView',
        component: () => import(/* webpackChunkName: "privacyPolicyView" */'@/views/setting/comp/setting-privacy-policy'),
      },
    ],
  },
]
